export enum ComparisonEntityType {
  Spec = 'spec',
  AcceptanceSpec = 'acceptance',
}

export const HAS_CHANGE_CLASS = "js-compare-has-change";
